// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__15j3n","content":"LayoutSettings_content__2H3XT"};